import { Chip, Typography } from '@mui/material';
import { type GridColDef } from 'esseal-data-table';

import { type CompanyHoliday } from '@/Contexts/Settings/Context';
import DateTimeFormatter from '@/shared-components/DateTimeFormatter';

export const getShiftLabel = (shift: string): string => {
  switch (shift) {
    case 'morning':
      return 'Morning Shift';
    case 'evening':
      return 'Evening Shift';
    case 'whole_day':
    default:
      return 'Whole Day';
  }
};

const companyHolidaysColumns: GridColDef<CompanyHoliday>[] = [
  {
    field: 'date',
    headerName: 'Date',
    width: 180,
    valueGetter: (row) => row.date,
    renderCell: ({ row }) => <DateTimeFormatter rawDate={row.date} />,
  },
  {
    field: 'shift',
    headerName: 'Shift Applied To',
    width: 180,
    valueGetter: (row) => getShiftLabel(row.shift),
    renderCell: ({ row }) => {
      const label = getShiftLabel(row.shift);
      const color = row.shift === 'whole_day' ? 'primary' : row.shift === 'morning' ? 'info' : 'secondary';
      return <Chip label={label} size="small" color={color} variant="outlined" />;
    },
  },
  {
    field: 'description',
    headerName: 'Description',
    width: 450,
    renderCell: ({ row }) => (
      <Typography variant="body2" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
        {row.description}
      </Typography>
    ),
  },
];

export default companyHolidaysColumns;
